'use strict';

var $ = window.jQuery;

var AutoLoadPages = require('../../lib/AutoLoadPages.js');

module.exports = {
	load: function() {
		if ($('.pagination').length === 0) {
			return;
		}
		
		// Setup auto load of next page of units as the user scrolls the results
		var autoLoadPages = new AutoLoadPages({
			scrollableArea: $(window),
			resultsSelector: '#queryResults',
			paginationSelector: '.pagination',
			nextSelector: '.next',
			loadWhenDistanceFromBottom: 200
		});
	},
	unload: function() {
	}
};